import { setAlert } from '../../alert';
import { getBudgetFeeSchedule, updateBudgetData } from '../budget';
import { currencyFormat } from '../../../../helpers';

export const FDIC_populateBudgetData = () => async(dispatch, getState) => {
    try {
        //	DESC: pre-set the errors array and set potential warning to this array and throw them at the end of logic
        // let errors = [];
        const {
            properties: {
                propertyFields: {
                    id,
                    assignment_date,
                    budget_current_period_length: period,
                    type_primary,
                    type_secondary,
                    value_current_appraised,
                    property_management_occupancy_status,
                    lot_size,
                    building_size,
                    year_built,
                    value_gross_approved,
                    value_tax_assessed,
                    // tax_current_amount_due,
                    // tax_previous_amount_due,
                    // tax_past_due_amount,
                    participation,
                    participation_log,
                    participation_percentage_owned
                }
            }
        } = getState();

        if (!value_current_appraised) {
            throw new Error('Current Valuation Report Value is required to populate Budget Table!');
        }

        const payload = {
            id,
            assignment_date,
            type_primary,
            value_current_appraised,
            property_management_occupancy_status
        };

        await dispatch(getBudgetFeeSchedule(payload));

        const { propertyBudget: { FeeSchedule, BudgetData } } = getState();
        const newFeeSchedule = { ...FeeSchedule };
        const {
            type,
            set_up_fee,
            monthly_admin_management_fee,
            disposition_fee,
            disposition_percentage,
            contingency,
            title_clearing_fee,
            appraisal_fee,
            //  Rename to prevent clash with participation above
            participation: participations
        } = newFeeSchedule;

        // let taxCurrentAmountDue = parseFloat(tax_current_amount_due || 0);
        // let taxPreviousAmountDue = parseFloat(tax_previous_amount_due || 0);
        // let taxPastDueAmount = parseFloat(tax_past_due_amount || 0);

        const tax_cycles = Math.ceil(period / 12);

        const realtor_disposition = Math.ceil(disposition_fee / 10) * 10 * tax_cycles;

        const land_types_sfr = [];
        // **5405 - Property Taxes**
        /* This should be 4% of appraised value - note section should read: "Estimated at 4% of appraised value, or state property tax + contingency." */
        const LINE_5405 = {
            recurring_items: 0,
            notes: ''
        };

        console.debug({
            value_tax_assessed,
            value_gross_approved
        });
        let propertyTaxInitialValue = 0;
        let propertyTaxMessage = '';
        if (value_tax_assessed) {
            propertyTaxInitialValue = parseFloat(value_tax_assessed) * 0.04;
            propertyTaxMessage =
				'Estimated at 4% of tax value or $500 (whichever is greater) annually to cover state property tax + contingency for unpaid/ past due taxes and/or increased rates.';
        }
        else if (value_gross_approved) {
            propertyTaxInitialValue = parseFloat(value_gross_approved) * 0.04;
            propertyTaxMessage =
				'Estimated at 4% of gross approved value or $500 (whichever is greater) annually to cover state property tax + contingency for unpaid/ past due taxes and/or increased rates.';
        }

        if (propertyTaxInitialValue < 500) {
            propertyTaxInitialValue = 500;
        }

        // times period - use modulo
        // if larger than 12 months, possible to pay property tax twice in a period
        // value = value * period;

        propertyTaxInitialValue = Math.ceil(propertyTaxInitialValue / 10) * 10;

        LINE_5405.recurring_items = (propertyTaxInitialValue * tax_cycles).toFixed(2);
        LINE_5405.note = propertyTaxMessage;
        // **5413 - Grounds**
        const LINE_5413 = {
            recurring_items: 0,
            non_recurring_items: 0,
            notes: ''
        };
        if (lot_size > 0) {
            let current_sqft = 0;
            let value = LINE_5413.recurring_items;
            if (building_size) {
                current_sqft = building_size;
            }
            switch (type) {
                case 'sfr': {
                    if (current_sqft > 0 <= 1500) {
                        value = current_sqft * 0.1;
                    }
                    else {
                        value = 1500 * 0.1 + (current_sqft - 1500) * 0.05;
                    }
                    break;
                }
                case 'commercial': {
                    value = 350;
                    break;
                }
                case 'land': {
                    if (land_types_sfr.includes(type_secondary)) {
                        if (lot_size <= 1) {
                            value = 75;
                        }
                        else if (lot_size > 1) {
                            value = 125;
                        }
                    }
                    else {
                        value = 25 * Math.ceil(lot_size);
                        if (value > 416) {
                            value = 416;
                        }
                    }
                    break;
                }
            }
            const initial_cleanup = Math.ceil(value * 2 / 10) * 10;
            value = Math.ceil(value / 10) * 10;

            if (value > 0) {
                LINE_5413.notes =
					currencyFormat(value) +
					'/month for grass cutting, weed abatement, trimming. Plus ' +
					currencyFormat(initial_cleanup) +
					' initial cleanup';
            }
            LINE_5413.recurring_items = value * period;
            LINE_5413.non_recurring_items = initial_cleanup;
        }

        //  5415 - Misc Operating Expense
        //	CHANGED ON 2019-12-12 PER BT; 1% OF value_current_appraised OR $2000 - WHICHEVER IS GREATER

        const miniumOperatingExpense = 2000;

        const LINE_5415 = {
            recurring_items: miniumOperatingExpense,
            notes: ''
        };

        if (value_current_appraised) {
            const value = parseFloat(value_current_appraised) * 0.01;
            LINE_5415.recurring_items = value > miniumOperatingExpense ? value : miniumOperatingExpense;
        }

        LINE_5415.notes = 'Contingency for miscellaneous expenses.';

        // 5414 - Utilities

        const LINE_5414 = {
            recurring_items: 0,
            non_recurring_items: 0,
            notes: ''
        };

        if (type !== 'land') {
            let value = LINE_5414.recurring_items;
            // .10 per sq. ft.; round up to the nearest ten
            let value_per_sqft = 0.1;
            let value_per_sqft_after_1000 = 0.07;
            let current_sqft = building_size;
            let first_1000_sqft_value = 150;
            let paid_sqft = 1000;
            if (type === 'commercial' || type === 'multi-family') {
                value = current_sqft * value_per_sqft;
            }

            if (type === 'sfr') {
                value = first_1000_sqft_value;
                current_sqft -= paid_sqft;

                if (current_sqft > 0) {
                    // BUILT BEFORE 1980
                    // .10 for every sq. ft. after 1000
                    if (year_built > 1980) {
                        value_per_sqft = value_per_sqft_after_1000;
                    }

                    value = value + current_sqft * value_per_sqft;
                }
            }

            value = Math.ceil(value / 10) * 10;
            LINE_5414.notes = currencyFormat(value) + '/month - estimated based on US averages.';
            LINE_5414.recurring_items = value * period;
        }

        const occupied_property_fixed_fees = 1500;
        const LINE_5411 = {
            non_recurring_item: 0,
            notes: ''
        };

        if (String(property_management_occupancy_status) === '1') {
            LINE_5411.non_recurring_item = occupied_property_fixed_fees;
            LINE_5411.notes = 'Contingency for tenant move-out cleaning fees.';
        }
        /* 5500 - Property Insurance
                     1% of appraised value
                     Note should read: "Calculated 1% of appraised value."*/
        const LINE_5500 = {
            recurring_items: 0,
            notes: 'Calculated 1% of appraised value.'
        };
        let propertyInsuranceValue = 0;
        if (value_current_appraised) {
            propertyInsuranceValue = parseFloat(value_current_appraised) * 0.01;
        }
        propertyInsuranceValue = Math.ceil(propertyInsuranceValue / 10) * 10;
        propertyInsuranceValue = (propertyInsuranceValue * period).toFixed(2);
        console.debug({ propertyInsuranceValue });

        LINE_5500.recurring_items = propertyInsuranceValue;

        /* 5421 - Environmental Remediation & Assessment
                     $3,500 for all properties. If creating a budget renewal, and there is a number in the prior expenses column,
                     then nothing should be budgeted for this category as only one environmental assessment should be necessary.
                     Note should read: "Estimate based on average cost from EMG Corp."*/

        const LINE_5421 = {
            non_recurring_items: 3500, // Fixed amount at 3500
            notes: 'Estimate based on average cost from EMG Corp.'
        };

        /* 5240 - Title Commitment
            $1,500 for all properties
            Note should read: "Estimate based on US averages." */
        const LINE_5240 = {
            non_recurring_items: 1500, // Fixed amount at 1500
            notes: 'Estimate based on US averages.'
        };

        //	 5256 - Survey & Testing

        const LINE_5256 = {
            non_recurring_items: 0,
            notes: ''
        };

        if (type === 'land') {
            if (lot_size >= 100) {
                LINE_5256.non_recurring_items = 8000;
            }
            else if (lot_size >= 50) {
                LINE_5256.non_recurring_items = 5000;
            }
            else if (lot_size >= 10) {
                LINE_5256.non_recurring_items = 3500;
            }
            LINE_5256.notes = 'Estimate based on US averages.';
        }

        //	5258 - Appraisal Fees
        const LINE_5258 = {
            non_recurring_items: appraisal_fee,
            notes: 'Based on US averages for full narrative appraisal.'
        };
        if (value_current_appraised >= 2500000) {
            LINE_5258.notes = 'Based on US averages for full narrative appraisal and corroborating appraisal.';
        }

        /* 5410 - Maintenance and Repairs
                     $5,000 for SFR/Land, $10,000 for commercial contingency + monthly inspection fee.
                     Note should read: "$xxx.xx/month inspection fee + $### contingency fee for any issues that may arise. */

        const LINE_5410 = {
            non_recurring_items: 0,
            recurring_items: 0,
            notes: ''
        };
        let maintenanceRepairsInspectionFee = 0;
        if (parseInt(building_size) === 0) {
            console.debug({ building_size });
            if (lot_size <= 0) {
                maintenanceRepairsInspectionFee = 0;
            }
            else if (lot_size < 2) {
                maintenanceRepairsInspectionFee = 50;
            }
            else if (lot_size < 5) {
                maintenanceRepairsInspectionFee = 75;
            }
            else if (lot_size < 10) {
                maintenanceRepairsInspectionFee = 100;
            }
            else if (lot_size >= 10) {
                maintenanceRepairsInspectionFee = 125;
            }
        }
        else if (building_size <= 2500) {
            console.debug({ building_size });
            if (lot_size <= 0) {
                maintenanceRepairsInspectionFee = 50;
            }
            else if (lot_size < 2) {
                maintenanceRepairsInspectionFee = 75;
            }
            else if (lot_size < 5) {
                maintenanceRepairsInspectionFee = 100;
            }
            else if (lot_size < 10) {
                maintenanceRepairsInspectionFee = 125;
            }
            else if (lot_size >= 10) {
                maintenanceRepairsInspectionFee = 150;
            }
        }
        else if (building_size <= 5000) {
            console.debug({ building_size });

            if (lot_size <= 0) {
                maintenanceRepairsInspectionFee = 75;
            }
            else if (lot_size < 2) {
                maintenanceRepairsInspectionFee = 100;
            }
            else if (lot_size < 5) {
                maintenanceRepairsInspectionFee = 125;
            }
            else if (lot_size < 10) {
                maintenanceRepairsInspectionFee = 137;
            }
            else if (lot_size >= 10) {
                maintenanceRepairsInspectionFee = 156;
            }
        }
        else if (building_size <= 10000) {
            console.debug({ building_size });

            if (lot_size <= 0) {
                maintenanceRepairsInspectionFee = 100;
            }
            else if (lot_size < 2) {
                maintenanceRepairsInspectionFee = 125;
            }
            else if (lot_size < 5) {
                maintenanceRepairsInspectionFee = 137;
            }
            else if (lot_size < 10) {
                maintenanceRepairsInspectionFee = 150;
            }
            else if (lot_size >= 10) {
                maintenanceRepairsInspectionFee = 162;
            }
        }
        else if (building_size > 10000) {
            console.debug({ building_size });

            if (lot_size <= 0) {
                maintenanceRepairsInspectionFee = 125;
            }
            else if (lot_size < 2) {
                maintenanceRepairsInspectionFee = 150;
            }
            else if (lot_size < 5) {
                maintenanceRepairsInspectionFee = 156;
            }
            else if (lot_size < 10) {
                maintenanceRepairsInspectionFee = 162;
            }
            else if (lot_size >= 10) {
                maintenanceRepairsInspectionFee = 175;
            }
        }

        LINE_5410.recurring_items = Math.ceil(maintenanceRepairsInspectionFee * period / 10) * 10;
        LINE_5410.non_recurring_items = Math.ceil(contingency / 10) * 10;
        LINE_5410.notes =
			currencyFormat(maintenanceRepairsInspectionFee) +
			'/month inspection fee + $' +
			contingency.toFixed(2) +
			' contingency fee for any issues that may arise.';

        // Participation

        if (participation === 'Y') {
            const leadParticipantPercentage = JSON.parse(participation_log).shift().Percentage;

            if (participation_percentage_owned >= leadParticipantPercentage) {
                 
                set_up_fee += participations.lead_participant.set_up_fee;
                 
                monthly_admin_management_fee += participations.lead_participant.monthly_admin_management_fee;
            }
            else {
                 
                set_up_fee = participations.non_lead_participant.set_up_fee;
                 
                monthly_admin_management_fee = participations.non_lead_participant.monthly_admin_management_fee;
            }
        }

        /* 5416 - Title Clearing Fee */

        const LINE_5416 = {
            non_recurring_items: parseFloat(set_up_fee) + parseFloat(title_clearing_fee),
            recurring_items: monthly_admin_management_fee * period,
            notes: currencyFormat(monthly_admin_management_fee) +
				'/mo Admin Mgmt Fee, ' +
				currencyFormat(set_up_fee) +
				' one time set up fee.'
        };

        if (title_clearing_fee > 0) {
            LINE_5416.notes =
				currencyFormat(monthly_admin_management_fee) +
				'/mo Admin Mgmt Fee, ' +
				currencyFormat(set_up_fee) +
				' one time set up fee, ' +
				currencyFormat(title_clearing_fee) +
				' title clearing fee.';
        }

        /* 5251 - Commission/Broker Fees */
        const LINE_5251 = {
            non_recurring_items: realtor_disposition.toFixed(2),
            notes: 'Estimated at ' + disposition_percentage + '% of appraised value per the fee schedule.'
        };

        //	5253 - Closing Costs
        const LINE_5253 = {
            non_recurring_items: 0,
            notes: 'Closing costs calculated at 5% of appraised value based on US average.'
        };

        let closing_cost = 0;
        const closing_percentage = 0.05;

        closing_cost = value_current_appraised * closing_percentage + closing_cost;
        LINE_5253.non_recurring_items = (Math.round(closing_cost / 10) * 10).toFixed(2);
        const newlyPopulatedBudgetData = {
            ...BudgetData,
            ['OPERATING EXPENSES']: {
                ...BudgetData['OPERATING EXPENSES'],

                5405: {
                    ...BudgetData['OPERATING EXPENSES'][5405],
                    ...LINE_5405
                },
                5410: {
                    ...BudgetData['OPERATING EXPENSES'][5410],
                    ...LINE_5410
                },
                5411: {
                    ...BudgetData['OPERATING EXPENSES'][5411],
                    ...LINE_5411
                },
                5413: {
                    ...BudgetData['OPERATING EXPENSES'][5413],
                    ...LINE_5413
                },
                5414: {
                    ...BudgetData['OPERATING EXPENSES'][5414],
                    ...LINE_5414
                },
                5415: {
                    ...BudgetData['OPERATING EXPENSES'][5415],
                    ...LINE_5415
                },
                5416: {
                    ...BudgetData['OPERATING EXPENSES'][5416],
                    ...LINE_5416
                },
                5500: {
                    ...BudgetData['OPERATING EXPENSES'][5500],
                    ...LINE_5500
                }
            },
            ['RESOLUTION EXPENSES']: {
                ...BudgetData['RESOLUTION EXPENSES'],
                5240: {
                    ...BudgetData['RESOLUTION EXPENSES'][5240],
                    ...LINE_5240
                },
                5251: {
                    ...BudgetData['RESOLUTION EXPENSES'][5251],
                    ...LINE_5251
                },
                5253: {
                    ...BudgetData['RESOLUTION EXPENSES'][5253],
                    ...LINE_5253
                },
                5256: {
                    ...BudgetData['RESOLUTION EXPENSES'][5256],
                    ...LINE_5256
                },
                5258: {
                    ...BudgetData['RESOLUTION EXPENSES'][5258],
                    ...LINE_5258
                },
                5421: {
                    ...BudgetData['RESOLUTION EXPENSES'][5421],
                    ...LINE_5421
                }
            }
        };
        dispatch(updateBudgetData(newlyPopulatedBudgetData));
        dispatch(setAlert('Budget Populated', 'success'));
    }
    catch (error) {
        dispatch(setAlert(error.message, 'error'));
    }
};